export var Permissions;
(function (Permissions) {
    Permissions["ACCOUNT_ANALYZER_SETTINGS"] = "ACCOUNT_ANALYZER_SETTINGS";
    Permissions["ACCOUNT_FIELD"] = "ACCOUNT_FIELD";
    Permissions["ACCOUNT_OPEN_SESSION"] = "ACCOUNT_OPEN_SESSION";
    Permissions["ACCOUNT_TOPIC"] = "ACCOUNT_TOPIC";
    Permissions["ADMIN_ACCOUNT_SAWMILL_NOTE"] = "ADMIN_ACCOUNT_SAWMILL_NOTE";
    Permissions["ADMIN_ACCOUNT_SAWMILL_PIPELINE"] = "ADMIN_ACCOUNT_SAWMILL_PIPELINE";
    Permissions["ADMIN_ACCOUNT_TOKEN_RESET_PERMISSION"] = "ADMIN_ACCOUNT_TOKEN_RESET_PERMISSION";
    Permissions["ADMIN_AUDIT_TRAIL"] = "ADMIN_AUDIT_TRAIL";
    Permissions["ADMIN_MANAGE_SECURITY_ACCOUNT"] = "ADMIN_MANAGE_SECURITY_ACCOUNT";
    Permissions["ADMIN_SUPPORT_ACCESS"] = "ADMIN_SUPPORT_ACCESS";
    Permissions["ADMIN_TIMELESS_INDICES"] = "ADMIN_TIMELESS_INDICES";
    Permissions["ADMIN_UPGRADE_KIBANA_VERSION"] = "ADMIN_UPGRADE_KIBANA_VERSION";
    Permissions["ALERTS"] = "ALERTS";
    Permissions["API_TOKENS"] = "API_TOKENS";
    Permissions["APP_STATE"] = "APP_STATE";
    Permissions["ARCHIVE"] = "ARCHIVE";
    Permissions["AUDIT_TRAIL"] = "AUDIT_TRAIL";
    Permissions["AUTHENTICATION_GROUPS"] = "AUTHENTICATION_GROUPS";
    Permissions["AUTHORIZATION_EDIT"] = "AUTHORIZATION_EDIT";
    Permissions["AWS_MARKETPLACE_ACCOUNT_OWNER"] = "AWS_MARKETPLACE_ACCOUNT_OWNER";
    Permissions["AWS_MARKETPLACE_ADMIN"] = "AWS_MARKETPLACE_ADMIN";
    Permissions["BUSINESS_ANALYTICS"] = "BUSINESS_ANALYTICS";
    Permissions["CLOUDTRAIL"] = "CLOUDTRAIL";
    Permissions["DATA_PARSING"] = "DATA_PARSING";
    Permissions["DOC_SIZE_SETTING"] = "DOC_SIZE_SETTING";
    Permissions["DRILLDOWNS_PERMISSION"] = "DRILLDOWNS_PERMISSION";
    Permissions["DROP_LOGS_FILTERS"] = "DROP_LOGS_FILTERS";
    Permissions["EDIT_OWNER_ACCOUNT"] = "EDIT_OWNER_ACCOUNT";
    Permissions["ENDPOINT_PERMISSION"] = "ENDPOINT_PERMISSION";
    Permissions["FIELD_MAPPINGS"] = "FIELD_MAPPINGS";
    Permissions["FORCE_IMPERSONATION"] = "FORCE_IMPERSONATION";
    Permissions["GET_ACCOUNT_USED_FIELDS_NUM"] = "GET_ACCOUNT_USED_FIELDS_NUM";
    Permissions["GET_ALL_ACCOUNTS_USED_FIELDS_NUM"] = "GET_ALL_ACCOUNTS_USED_FIELDS_NUM";
    Permissions["GET_PERMISSIONS"] = "GET_PERMISSIONS";
    Permissions["GET_SEARCHABLE_ACCOUNTS"] = "GET_SEARCHABLE_ACCOUNTS";
    Permissions["GLOBAL_NOTIFICATIONS"] = "GLOBAL_NOTIFICATIONS";
    Permissions["IMPERSONATION"] = "IMPERSONATION";
    Permissions["INSIGHTS"] = "INSIGHTS";
    Permissions["LIVE_TAIL_SESSIONS"] = "LIVE_TAIL_SESSIONS";
    Permissions["LOGS_PATTERNS"] = "LOGS_PATTERNS";
    Permissions["LOOKUP_LISTS"] = "LOOKUP_LISTS";
    Permissions["MANAGE_SECURITY_ACCOUNT"] = "MANAGE_SECURITY_ACCOUNT";
    Permissions["MARKERS"] = "MARKERS";
    Permissions["METRICS_ACCOUNT"] = "METRICS_ACCOUNT";
    Permissions["METRICS_ACCOUNT_MANAGEMENT"] = "METRICS_ACCOUNT_MANAGEMENT";
    Permissions["METRICS_ACCOUNT_READ"] = "METRICS_ACCOUNT_READ";
    Permissions["METRICS_ACCOUNT_ROLLUP_CONFIG_READ"] = "METRICS_ACCOUNT_ROLLUP_CONFIG_READ";
    Permissions["METRICS_ACCOUNT_ROLLUP_CONFIG_WRITE"] = "METRICS_ACCOUNT_ROLLUP_CONFIG_WRITE";
    Permissions["METRICS_ACCOUNT_WRITE"] = "METRICS_ACCOUNT_WRITE";
    Permissions["METRICS_BUDGET_READ"] = "METRICS_BUDGET_READ";
    Permissions["METRICS_BUDGET_WRITE"] = "METRICS_BUDGET_WRITE";
    Permissions["METRICS_COMMON_ROLLUP_CONFIG_READ"] = "METRICS_COMMON_ROLLUP_CONFIG_READ";
    Permissions["METRICS_ROLLUP_CONFIG_MANAGEMENT"] = "METRICS_ROLLUP_CONFIG_MANAGEMENT";
    Permissions["METRICS_COMMON_ROLLUP_CONFIG_WRITE"] = "METRICS_COMMON_ROLLUP_CONFIG_WRITE";
    Permissions["READ_ALERTS"] = "READ_ALERTS";
    Permissions["READ_SECURITY_RULES_PERMISSION"] = "READ_SECURITY_RULES_PERMISSION";
    Permissions["READ_THREATS_FEEDS_PERMISSION"] = "READ_THREATS_FEEDS_PERMISSION";
    Permissions["REFRESH_KIBANA_MAPPINGS"] = "REFRESH_KIBANA_MAPPINGS";
    Permissions["SAVE_KIBANA_OBJECT"] = "SAVE_KIBANA_OBJECT";
    Permissions["SCHEDULED_REPORTS"] = "SCHEDULED_REPORTS";
    Permissions["SEARCH_ADMIN_PERMISSION"] = "SEARCH_ADMIN_PERMISSION";
    Permissions["SECURITY_RULES_PERMISSION"] = "SECURITY_RULES_PERMISSION";
    Permissions["SEND_YOUR_DATA_PAGE"] = "SEND_YOUR_DATA_PAGE";
    Permissions["SHARED_OBJECTS"] = "SHARED_OBJECTS";
    Permissions["SHARED_TOKENS"] = "SHARED_TOKENS";
    Permissions["SNAPSHOT"] = "SNAPSHOT";
    Permissions["SUB_ACCOUNT"] = "SUB_ACCOUNT";
    Permissions["SUPPORT_ACCESS"] = "SUPPORT_ACCESS";
    Permissions["THREATS_FEEDS_PERMISSION"] = "THREATS_FEEDS_PERMISSION";
    Permissions["THREATS_PRIVATE_FEEDS_PERMISSION"] = "THREATS_PRIVATE_FEEDS_PERMISSION";
    Permissions["TIMELESS_INDICES"] = "TIMELESS_INDICES";
    Permissions["TRIGGER"] = "TRIGGER";
    Permissions["TRIGGER_ADMIN"] = "TRIGGER_ADMIN";
    Permissions["USER_MANAGEMENT_ADMIN_PERMISSION"] = "USER_MANAGEMENT_ADMIN_PERMISSION";
    Permissions["USER_MANAGEMENT_PERMISSION"] = "USER_MANAGEMENT_PERMISSION";
    Permissions["USER_SESSION_PERMISSION"] = "USER_SESSION_PERMISSION";
    Permissions["UTILIZATION_SETTINGS"] = "UTILIZATION_SETTINGS";
    Permissions["WEEKLY_REPORT_SETTINGS"] = "WEEKLY_REPORT_SETTINGS";
    Permissions["ADD_SUB_ACCOUNT"] = "ADD_SUB_ACCOUNT";
    Permissions["DELETE_SUB_ACCOUNT"] = "DELETE_SUB_ACCOUNT";
    Permissions["ACTIVATE_FLEXIBLE_USAGE"] = "ACTIVATE_FLEXIBLE_USAGE";
    Permissions["FINANCE_CONSOLE_PERMISSION"] = "FINANCE_CONSOLE_PERMISSION";
    Permissions["LOG_METRIC_CREATE"] = "LOG_METRIC_CREATE";
    Permissions["LOG_METRIC_READ"] = "LOG_METRIC_READ";
    Permissions["LOG_METRIC_DELETE"] = "LOG_METRIC_DELETE";
    Permissions["LOG_METRIC_UPDATE"] = "LOG_METRIC_UPDATE";
    Permissions["LOG_METRIC_SET_ENABLED"] = "LOG_METRIC_SET_ENABLED";
})(Permissions || (Permissions = {}));
//# sourceMappingURL=permissions.js.map